import { render } from "./contentBorder.vue?vue&type=template&id=76dbc3aa"
import script from "./contentBorder.vue?vue&type=script&lang=js"
export * from "./contentBorder.vue?vue&type=script&lang=js"

import "./contentBorder.vue?vue&type=style&index=0&id=76dbc3aa&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__